// extracted by mini-css-extract-plugin
export default {"root":"BarChartSubtitle_root__v2zJS","column":"BarChartSubtitle_column__akw3g","circle":"BarChartSubtitle_circle__sJmWW","circleRed":"BarChartSubtitle_circleRed__-Ri81"};